module.exports = __webpack_public_path__ + "img/git-branch.6e92e8b9.svg";